import { Pueblo } from '../../models/pueblo.model';
import { HighlightifyPipe } from '../../pipes/highlightify/highlightify';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, MenuController } from 'ionic-angular';
import { Consultas } from '../../providers/consultas';
import { VariablesGlobales } from '../../providers/variables-globales';
import { Empresa } from '../../models/empresa.model';
import { EmpresaSinglePage } from '../empresa-single/empresa-single';
/**
 * Generated class for the FiltroPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-filtro',
  templateUrl: 'filtro.html',
  providers: [Consultas]
})
export class FiltroPage {
  public query: string;
  public loader: any;
  public pueblos: Array<any>;
  public provincias: Array<any>;
  public categorias: Array<any>;
  public zonas: Array<any>;
  public barrios: Array<any>;
  public empresas: Array<Empresa> | null;
  public parking: string;
  private idProvincia: number | string = '';
  private idCiudad: number | string = '';
  private idCategoria: number | string = '';
  private idEmpresaZona: number | string = '';
  public latitud: number;
  public longitud: number;
  private idCiudadZona: number | string = '';
  options = {
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 0,
  };

  constructor(
    public consultas: Consultas,
    public loadingCtrl: LoadingController,
    public global: VariablesGlobales,
    public navCtrl: NavController,
    public navParams: NavParams, public menuCtrl: MenuController) {

  }

  ngOnInit() {
    navigator.geolocation.getCurrentPosition(this.successCallback, this.errorCallback, this.options);
    this.loadBaseData();
  }

  loadBaseData(){
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(() => {
      this.consultas.getListaCategorias(this.idProvincia,this.idCiudad,this.idEmpresaZona,this.idCiudadZona).subscribe(x => {
        this.categorias = x;
      }, error => {
        console.error(error);
      }, () => {
      }
      );
      this.consultas.getBarrios().subscribe(x => {
        this.barrios = x;
      }, error => {
        console.error(error);
      }, () => {
      }
      );
      this.consultas.getZonas().subscribe(x => {
        this.zonas = x;
      }, error => {
        console.error(error);
      }, () => {
      }
      );
      this.consultas.getPueblos().subscribe(x => {
        this.pueblos = x;
      }, error => {
        console.error(error);
        this.loader.dismiss();
      }, () => {
        this.loader.dismiss();
      }
      );
      this.consultas.getProvinciasComunidad('').subscribe(x => {
        this.provincias = x;
      }, error => {
        console.error(error);
      }, () => {
      }
      );
    });
  }
  onSelectPueblo(event){
    if(event){
      this.idCiudad = event;
      this.consultas.getBarriosByCiudad(event).subscribe(x => {
        this.barrios = x;
      }, error => {
        console.error(error);
        this.loader.dismiss();
      }, () => {
        this.loader.dismiss();
      }
      );
      this.consultas.getListaCategorias(this.idProvincia,this.idCiudad,this.idEmpresaZona,this.idCiudadZona).subscribe(x => {
        this.categorias = x;
      }, error => {
        console.error(error);
      }, () => {
      }
      );
    }
  }
  onSelectProvincia(event){
    if(event){
      this.idProvincia = event;
      this.consultas.getPueblosProvincia(event).subscribe(x => {
        this.pueblos = x;
      }, error => {
        console.error(error);
        this.loader.dismiss();
      }, () => {
        this.loader.dismiss();
      }
      );
      this.consultas.getBarriosByProvincia(event).subscribe(x => {
        this.barrios = x;
      }, error => {
        console.error(error);
        this.loader.dismiss();
      }, () => {
        this.loader.dismiss();
      }
      );
      this.consultas.getZonasByProvincia(event).subscribe(x => {
        this.zonas = x;
      }, error => {
        console.error(error);
        this.loader.dismiss();
      }, () => {
        this.loader.dismiss();
      }
      );
      this.consultas.getListaCategorias(this.idProvincia,this.idCiudad,this.idEmpresaZona,this.idCiudadZona).subscribe(x => {
        this.categorias = x;
      }, error => {
        console.error(error);
      }, () => {
      }
      );
    }
  }
  goToEmpresa(empresa) {
    this.navCtrl.push(EmpresaSinglePage, { empresa });
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad FiltroPage');
  }
  buscar() {
    this.consultas.getBusquedaParametrizada(this.idProvincia, this.idCiudad, this.idCategoria, this.idEmpresaZona, this.idCiudadZona)
      .subscribe(data => {
        if(data && data.length > 0){
          this.empresas = data as Array<Empresa>;
          if(this.latitud && this.longitud){
            this.empresas.forEach(x=>{
                if(x.maps && x.maps.includes("@")){
                  const parteCoordenadas = x.maps.split("@")[1];
                  const latitud = parteCoordenadas.split(",")[0];
                  const longitud = parteCoordenadas.split(",")[1];
                  x.distancia = this.getDistanciaMetros(this.latitud,this.longitud,latitud,longitud) /1000;
                }
            });
            this.empresas.sort((a,b)=>{
              return a.distancia - b.distancia;
            });
            console.log(this.empresas);
          }
        }else
        {
          this.empresas = [];
        }
      }, error => {
        console.error(error);
      }, () => {
      });
  }

  successCallback = (position) =>{
    this.latitud = position.coords.latitude;
    this.longitud = position.coords.longitude;
  };

  getDistanciaMetros(lat1,lon1,lat2,lon2)
  {
    const rad = function(x) {return x*Math.PI/180;}
    const R = 6378.137; //Radio de la tierra en km
    const dLat = rad( lat2 - lat1 );
    const dLong = rad( lon2 - lon1 );
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(rad(lat1)) *
    Math.cos(rad(lat2)) * Math.sin(dLong/2) * Math.sin(dLong/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

    //aquí obtienes la distancia en metros por la conversion 1Km =1000m
    const d = R * c * 1000;
    return d ;
  }

  errorCallback(error){
    var errorMessage = 'Unknown error';
    switch(error.code) {
      case 1:
        errorMessage = 'Permission denied';
        break;
      case 2:
        errorMessage = 'Position unavailable';
        break;
      case 3:
        errorMessage = 'Timeout';
        break;
    }
    console.log(errorMessage)
    //document.write(errorMessage);
  };

  limpiar(){
    this.idCiudadZona = this.idEmpresaZona = this.idCiudad = this.idProvincia = this.idCategoria = '';
    this.empresas = [];
    this.loadBaseData();
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/filtro/filtro.ts